var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _image, _image2, _image3, _image4, _image5, _image6, _image7, _image8, _image9, _image0, _image1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnabler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.227,
    cy: 33.242,
    rx: 33.227,
    ry: 33.242,
    style: {
      fill: "url(#_Linear1)"
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 4.493,
    y: 31.994,
    width: "15.21px",
    height: "20.888px",
    transform: "matrix(0.950623,0,0,0.99468,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.968,45.292c-1.809,-3.035 -3.191,-6.353 -4.062,-9.872",
    style: {
      fill: "url(#_Linear3)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image4",
    x: 3.611,
    y: 28.245,
    width: "12.267px",
    height: "11.427px",
    transform: "matrix(0.943645,0,0,0.952228,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.204,31.812c-0.058,-0.41 -0.11,-0.821 -0.155,-1.235",
    style: {
      fill: "url(#_Linear5)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 4.412,
    y: 23.822,
    width: "10.269px",
    height: "10.601px",
    transform: "matrix(0.93352,0,0,0.96377,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.84,27.073c-0.002,-0.152 -0.003,-0.304 -0.003,-0.456",
    style: {
      fill: "url(#_Linear7)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image8",
    x: 9.601,
    y: 27.704,
    width: "15.941px",
    height: "19.324px",
    transform: "matrix(0.996331,0,0,0.966218,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.089,39.611c-1.974,-2.768 -3.338,-5.874 -3.934,-9.189",
    style: {
      fill: "url(#_Linear9)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 10.811,
    y: 23.445,
    width: "10.275px",
    height: "10.788px",
    transform: "matrix(0.934111,0,0,0.980695,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.828,27.327c-0.008,-0.236 -0.012,-0.473 -0.012,-0.71",
    style: {
      fill: "url(#_Linear11)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image12",
    x: 16.368,
    y: 23.016,
    width: "13.309px",
    height: "18.885px",
    transform: "matrix(0.950669,0,0,0.993973,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.357,34.343c-1.373,-2.303 -2.162,-4.994 -2.162,-7.868",
    style: {
      fill: "url(#_Linear13)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 22.608,
    y: 23.277,
    width: "13.162px",
    height: "14.827px",
    transform: "matrix(0.940115,0,0,0.98846,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.942,30.409c-0.662,-1.11 -1.042,-2.407 -1.042,-3.792",
    style: {
      fill: "url(#_Linear15)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image16",
    x: 10.08,
    y: 25.788,
    width: "40.341px",
    height: "33.361px",
    transform: "matrix(0.983938,0,0,0.981205,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.435,30.408c1.939,3.396 4.612,8.266 7.894,14.166c-10.038,5.533 -26.627,6.952 -27.285,5.771c-0.585,-1.05 9.704,-14.527 19.391,-19.937Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image17",
    x: 34.358,
    y: 23.819,
    width: "20.342px",
    height: "22.315px",
    transform: "matrix(0.968678,0,0,0.970232,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.399,37.482c0,0 3.197,-6.115 4.411,-7.658c0.638,-0.812 2.868,-1.598 2.868,-1.598",
    style: {
      fill: "url(#_Linear18)",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image19",
    x: 38.992,
    y: 15.208,
    width: "28.119px",
    height: "22.649px",
    transform: "matrix(0.96962,0,0,0.984729,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.655,21.349c0.634,1.138 0.318,2.525 -0.706,3.095c-1.024,0.57 -13.366,6.238 -14,5.1c-0.634,-1.138 10.679,-8.653 11.702,-9.223c1.024,-0.57 2.37,-0.11 3.004,1.028Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.399,37.482c0,0 3.197,-6.115 4.411,-7.658c0.638,-0.812 2.868,-1.598 2.868,-1.598",
    style: {
      fill: "url(#_Linear20)",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.435,30.408c1.939,3.396 4.612,8.266 7.894,14.166c-10.038,5.533 -26.627,6.952 -27.285,5.771c-0.585,-1.05 9.704,-14.527 19.391,-19.937Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3
    }
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image21",
    x: 24.379,
    y: 33.97,
    width: "20.944px",
    height: "17.583px",
    transform: "matrix(0.997339,0,0,0.976855,0,-2.27374e-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.905,43.33l9.936,-5.537",
    style: {
      fill: "none",
      stroke: "#fae4bb",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.13687e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "16px",
    height: "21px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAYAAABPPm7SAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA10lEQVQ4jZVUwQ2DMBBzApPw6Jsh+usSHY0l+DFE/5U6CumHINfxReWkCOkS++zLhQSKx/2ZEMS6LcXlTwCBHUmJSJIBRwSWJAtZXZkW5xuboySSAqj6znYiBfWb8aeKUbw6BVxoP/JFN1xwPxriqoIJzk53FDVXnc3duoGJrGEAgNs0K3sI4AK3aW4sqB22ZYctAz/TpUAmsG9Br/ESGDh6AADvz6v2oheqtFGgh+rg6FifigZGkgrXeWvHKVAV3ec96M6VXqzbUsKDvd9bBSOQ1yXT0f8CC+tbLoqHf48AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,4.54747e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image4",
    width: "13px",
    height: "12px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAcUlEQVQokZ2RwQ3AIAhFwTiaN5dwNJbw5m70pPlQaJv+hASRnyfIBOptMCWaS3Tn5cFgznjPrpCRDmUu0Ro0vBqro+zwzYzGiBTRDqW3wYV+KCNpUqe5RAvsXz9ESEICZ8QzsPtcsy18mjEFxtssO78ACDkr98cbnNUAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,4.54747e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image6",
    width: "11px",
    height: "11px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAYElEQVQYlWNkgAJvlwRGBhxg654F/xkYGBgYCSlE1sCIphCbpv8wBhMWhYxIGMUAZMXYTEbhoyvG5xyciv9jE0RXjK4IhY8edDhDY+ueBf9ZiLEexWQ001EALPYYGBgYAEW6FwjJYx+lAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,4.54747e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image8",
    width: "16px",
    height: "20px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA3klEQVQ4jZVUuQ3DMBCjZE/iIrWHSJclMlqWSJch0gfIKL40PoGiKQM54HCSbVK8xyogu13vBcaer0e45wDQAALmdQM7oiJgjUwQjmQWsvTcB8VOTVo10guAKnGUalNQxKuksBFJp4I/dCpYQVPCKuYBmGXnIYFjTQ4ESuaIbQqjKmtdDmlU6msMnNVoeraIDHRqOpsA4LKsoxN0Ipk4LstaJgD4fN9nJE5dI9Mu5Itt37sid+lNuRAVKl/Bp3OQL3N8dYS737vrwqCl2+5BsZHYG+ify8USGJLO+FL5AfKAXSUVCEAXAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,2.27374e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image10",
    width: "11px",
    height: "11px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAW0lEQVQYlWNkgAJvlwRGBhxg654F/xkYGBgYsShEZv9H1sCIRyGGBhY0hbic8h9ZMUFnMDAwMDDhMAkdMCIr/o9HIYYzMCSwARYiFMHFsYUzXJwBPZxhHGJiEAAe8xsIwJlMjAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,2.27374e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image12",
    width: "14px",
    height: "19px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAATCAYAAACgADyUAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAv0lEQVQ4jZVTsQ3DMAyjbF/SoXOPyOYnfFqf6NYjuhfoJ4072aBlaigBAbEiSqQSGwj1aIYAj+e983kWEkmRuyebIEXEhZzc9BGJgvNzSHG+zMXii2WXYBpL7wBOJjGRsUij4u9oVI9mSZCUZHPv5ETfxDfatrp4wL6Y5TMlUdTprLYKAMjvzwvXyy3yxji5offYKU7sm53PxScciYlsARkASK76W6RfJdWiYp6aR8YtKcK8IbLwnwstUY9mUZMfh6JK/JYlNdkAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,3.41061e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image14",
    width: "14px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAApElEQVQokY2TwQ3DIAxFHwmT9NBzh8gtS2S0LJFbhug9UkeJewJ9jKn6JSQwfnxjQUK0LltioOPcTdc1UaAINg+nABqBDTw59zImGRqvJtndq0kayACygyLYgFshLdU7eNdmf122VMCm1cEhnbQ55uYWxKvm6/Pm+XhpaXo3C+Yc527anLJx0zenUw5ioxIb1xlAyv2l5uV0yf8+9GGSHuB/BsAXZ287HdAgPqEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,1.13687e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    id: "_Image16",
    width: "41px",
    height: "34px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAiCAYAAADCp/A1AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACY0lEQVRYhbWYwVHDMBBFv+3QCIecKYIbTVBamsiNIrgzQyGQxBzwJt/ffyWZmJ3RSAFFevorrVbp8M/28vza8efj22FcO0ZX77LeFIzmmQG2Am8KSXBas41ct4BuBimAWtguE2CUKugmkBNgjNVP7Z7aYeMEeaF2FXS3ARwwV60HMBBkgDLgmQEhe1Vt2BAw4HZUHqa/MbTdp/vHp+7j893O9SclBTAmDpgdtQf6f6io7h9xU9raaiUNYI+5clFHUVgFjDb2j09waq5SMgFkBbUEWCjJ8dIeIGfNShYAVTlVcMAyFI1JsWo2QVYAHaTbkxno4pTrIaq6uxGQXezA+GAME5jWl+l7C9cXlVwBGLWLj2qsmnU5JCSlSq4EzGKhg+wnGKekDUl9BvlPgBz4OTLo9zvgJpSFpLu4wzLM3AO4GtRCGkB33fGt0gKosDq23vczyNmAtA91lRFaskPSCgjMQ88ZwAnAF4Bvqk+4JSHW3bpSTRjuBXTmctCrmtfTnbjZudiFmBKggrmQU1rAL2TjnZxdcwroJnOx0eWWdgEcJ7O8MLviMiinjk7OgCfM9+AiO3KQTs3sKaCmUNzmjIchi6DHt8O4k+cnA5YSg1YwBzcSDNdnLJ8VAG5KZhtf8z+12j3sAHUv6r5Uly/crcYpv4KW9lsLpEt67VOXIXnSWF2AB2hn+rZCujo90fzEDUjOPNgFAZgdmhpkDWiU8ez7m7ON2ru5FbIE4topXFjm7jOpoIAZqEJrH66rYGzXyQu/5cz6mckcgIVaA2YhDajtI5bFzLug1CyA+X2x2baAUvsBJwN/QePoZRkAAAAASUVORK5CYII="
  })), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    id: "_Image17",
    width: "21px",
    height: "23px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAXCAYAAADk3wSdAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABI0lEQVQ4jZWUQQ6CMBBFf5GTuHDtIdhxCY7mJdx5CPcm3oTWBXzz/Z0CTjIpNM3jDZ024Y8Yhyn53P1xKz5XLToA0vcvUOGbUAH6qFEIJ7gJNaAm50qQuD9upT8A7GzUyCssizUq6Aawk/ev2QpM8l5Dg5JPDSgtf+zHYUq9T5glU8FqF+5JZOqWTAKLjPobACwbxYW01PSS3azaeUZnZUela9kEZMkK3BksAvKDhM1rZoex+RWqYO/LyPDHVI9pZNr6fyHMgQDQRzePGaJhmGEb5KYO1uYmYEYAi64+9qmeDN3NuWEalu1QNfQj6JtU9aXH6fV+4nK+ep/qR8J+bFm6qd86UQXYAwLLmUZgW4LnXUNGdW1tLT4C3IxxmNLeR1rxAe31rRttm/E9AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image0 || (_image0 = /*#__PURE__*/React.createElement("image", {
    id: "_Image19",
    width: "29px",
    height: "23px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAXCAYAAAD3CERpAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABUUlEQVRIiaWVUXLDMAhEsauj9a+X6NF6if71aJWSj86SZQE7bphhrEgTPS0gsdmL9vH+uXVr3z9ft2q+/cNFWLWPAxV+GUow/nZQeICPF4DwXQ4AyBKww59SegLbBczASeNl9qf2VGkB3Mnf5LcRYMohPAqt0gN1gLGzUkB/yaF4mTU5fULdKKC7PXI3aewwqE1QAUKBKqugCB9yiDn2XL0FUEM5LEM5tMgdezKHngAHOR8iqRC1fG0i9ACoMHw5dFCIXKJo+LrgMCm8WqWqsqtULpZpj2rlAzi8uqcK7O4hOwPVAzCEt1BaPXEapmURyGCeS3kdR61JFE2Zq4BLPLy7Zw8+b6yVqSorkBZQaG+bmVev5pPf1uowHaiFwVSpdwPaYCvWb8U4wDqgQrkPMkCvhwLKRn1krqLpKmqq5hIsQQWc1grwJVALbeDB/gtiuwO3o+cXGydNvgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear20",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(28.4866,66.4836,-66.4836,28.4866,23.9457,-1.81899e-12)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  })), _image1 || (_image1 = /*#__PURE__*/React.createElement("image", {
    id: "_Image21",
    width: "21px",
    height: "18px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAYAAAC0EpUuAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAyUlEQVQ4jZ3UwQ3DIAwF0E/FaL11iY7GEtyYLe6lTn/Md0hqCYECPAxJKPgjXs938XYfzWJ/iQ9WSBaMLwcTyGMLAM7QGE5RgZVkvFFBH83qDUyh8TznTAN4Vhzbvm2vDQBqABl9EMJt3nI8W+xoAB2I9WrrPzR8Lgxx27M3UQ7RRzOekBUGeevpAtPbT1CeKF+OZ5mhHiZqhjbu4z9Kobz62VblmSqUvz+10ISpC6XSJIVn2UvMowD3Lo0VeEDuXm+XUIVfRWJ8AIgNeCGwvn0dAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnabler);
export default __webpack_public_path__ + "static/media/icon-enabler.9f02287a0392d0b3da5d81c53afca172.svg";
export { ForwardRef as ReactComponent };